<template>
  <div class="">

    <template v-if="broker != null">
      <Header :broker="broker" />
      
      <div class="my-12" style="">
        <router-view />
      </div>
    </template>

    <div class="invisible lg:visible fixed bottom-0 left-0">
      <div class="p-4 text-sm text-gray-600">
        Powered by 
        <a href="https://www.brokerpad.com.au" target="_blank" class="underline hover:text-black">{{ getAppName }}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from "./Header"

  export default {

    data() {
      return {
        broker     : null,
        leadCapture: null,
      }
    },

    components : {
      Header
    },

    created() {
      // this.logActivity({
      //   type        : 'lead-capture-visited',
      //   brokerId    : this.$route.params.brokerId,
      //   currentView : this.$store.state.view
      // })

      if(this.$route.params.id != null) {
        let brokerId = this.$route.params.id.split("-")[1]
        this.$router.push({
          name  : 'client-lead-capture',
          params: {
            brokerId : brokerId
          }
        })
        // this.apiGet({
        //   brokerId: this.$route.params.id.split("-")[1],
        // }, 'common/broker', (broker) => {
        //   this.broker = broker
        // })
      }

      else {
        this.apiGet({
          brokerId: this.$route.params.brokerId,
        }, 'common/broker', (broker) => {
          this.broker = broker
          // this.$router.push({
          //   name  : 'client-lead-capture-primary-reason',
          //   params: {
          //     brokerId : brokerId
          //   }
          // })
        })
      }
    },
  }
</script>